import {ref} from 'vue';

export const appUpdateRegistration = ref(null);
